import { FC, ChangeEvent, useState, KeyboardEvent, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useQuery, useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useStyles } from './styles';
import { ConfirmActionDialog } from 'components/Dialogs';
import { TextField, Button, Grid, Table, TableBody, TableCell, TableRow, Paper } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

export const SmtpSettingsForm: FC = observer(() => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: Settings: SMTP';
  }, []);

  const {
    smtpSettingsFormStore: { firstSettingsBlock, secondSettingsBlock, getSettings, putSettings, changeSettingValue },
    notificationStore: { openNotification },
  } = useStore();

  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

  const getSettingsReq = useQuery('getSettingsReq', () => getSettings(), {
    onError: () => openNotification('error', `Can't get Smtp settings`),
  });

  const putSettingsReq = useMutation(() => putSettings(), {
    mutationKey: 'putSettingsReq',
    onSuccess: () => openNotification('success', `Successfully updated`),
    onError: () => openNotification('error', `Can't update Smtp settings`),
  });

  useAppPreloader(getSettingsReq.isFetching || putSettingsReq.isLoading);

  const handleClose = () => {
    setOpenConfirmDialog(false);
    getSettingsReq.refetch();
  };

  const handleEnterPressed = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Enter') {
      setOpenConfirmDialog(true);
    }
  };

  return !getSettingsReq.isFetching ? (
    <>
      <div onKeyDownCapture={handleEnterPressed}>
        <h2 className={classes.textBox}>
          Here are the default email server settings that are used to send email alerts to you and your End Users. These
          settings are temporary and expire in 30-days or after 100 emails , whichever is eariler.So please update these
          settings with your own organization's email server. Max number of emails sent per hour: 20.
        </h2>
        <Paper className={classes.paper}>
          <Table className={classes.border} aria-label='simple table'>
            <TableBody>
              {firstSettingsBlock.map((setting, index) => (
                <TableRow key={index} className={classes.tablerow}>
                  <TableCell
                    className={`${classes.border}
                   ${classes.cellTitle}`}
                  >
                    {setting.name}
                  </TableCell>
                  <TableCell className={classes.border}>
                    <TextField
                      className={classes.textField}
                      type={`${setting.name}` === 'SMTP port' ? 'number' : 'text'}
                      autoFocus={index === 0}
                      key={setting.key}
                      value={setting.value}
                      InputProps={{ disableUnderline: true }}
                      onChange={(event: ChangeEvent<{ value: string }>) =>
                        changeSettingValue(setting.key, event.target.value)
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
              {secondSettingsBlock.map((setting, index) => (
                <TableRow key={index}>
                  <TableCell className={`${classes.border} ${classes.cellTitle}`}>{setting.name}</TableCell>
                  <TableCell className={classes.border}>
                    <TextField
                      className={classes.textField}
                      type={`${setting.name}` === 'SMTP port' ? 'number' : 'text'}
                      autoFocus={index === 0}
                      key={setting.key}
                      value={setting.value}
                      InputProps={{ disableUnderline: true }}
                      onChange={(event: ChangeEvent<{ value: string }>) =>
                        changeSettingValue(setting.key, event.target.value)
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        <Grid container>
          {/* <Grid container xs={6}>
            {firstSettingsBlock.map((setting, index) => (
              <Grid key={index} container className={classes.row}>
                <div className={classes.title}>
                  <p>{setting.name}</p>
                </div>
                <TextField
                  className={classes.textField}
                  autoFocus={index === 0}
                  key={setting.key}
                  value={setting.value}
                  onChange={(event: ChangeEvent<{ value: string }>) =>
                    changeSettingValue(setting.key, event.target.value)
                  }
                />
              </Grid>
            ))}
          </Grid>
          <Grid container xs={6}>
            {secondSettingsBlock.map((setting, index) => (
              <Grid key={index} container className={classes.row}>
                <div className={classes.title}>
                  <p>{setting.name}</p>
                </div>
                <TextField
                  className={classes.textField}
                  key={setting.key}
                  value={setting.value}
                  onChange={(event: ChangeEvent<{ value: string }>) =>
                    changeSettingValue(setting.key, event.target.value)
                  }
                />
              </Grid>
            ))}
          </Grid> */}
          <ConfirmActionDialog
            label='Update Settings'
            buttonLabel='Confirm'
            openModal={openConfirmDialog}
            action={() => putSettingsReq.mutate()}
            handleClose={handleClose}
            gitStatus=''
          />
        </Grid>
        <div>
          <Button
            disabled={getSettingsReq.isFetching || putSettingsReq.isLoading}
            className={classes.btn}
            size='small'
            variant='contained'
            color='secondary'
            onClick={() => setOpenConfirmDialog(true)}
          >
            Save Changes
          </Button>
        </div>
      </div>
    </>
  ) : null;
});
